module.exports = __webpack_public_path__ + "static/media/banner_390x520-website_(1)_(1).8432d94f.jpeg";